import { InputValidation } from '../../../../dependencies';

const { getFieldsErrors, validatorsWithMessage, translate } = InputValidation;
const { isRequired, isAlphaNumeric } = validatorsWithMessage;

// TODO: use isNowOrFutureDay only for create expense, not for edit!!!
const validators = {
    supplier: isRequired,
    number: [isAlphaNumeric],

    issuedOn: [isRequired],

    vatFromBase: isRequired,
    taxDeductible: isRequired,
    currency: isRequired,
    documentType: isRequired,
    item: {
        vatRate: isRequired,
        pricePerUnit: isRequired,
    },
};

export default function validate({ items = [], ...values }, { intl }) {
    const errors = {
        ...getFieldsErrors(validators, values),
        items: items.map(item => getFieldsErrors(validators.item, item)),
    };

    return translate(intl.formatMessage, errors);
}
